import api from "../utils/axios/axiosConfig";

const usersService = {
  getCurrentUser: () => api.get("/users/current-user"),

  getUser: (id) => api.get(`/users/get/${id}`),

  createUser: (data) => api.post("/users/create", data),

  updateUser: (id, data) => api.put(`/users/update/${id}`, data),

  deleteUser: (id) => api.delete(`/users/delete/${id}`),

  searchUsers: (params) => api.post("/users/search", params),

  searchAdmins: () => api.get("/users/search-admins"),

  searchAllUsers: () => api.get("/users/search-users"),

  getProfile: () => api.get("/users/profile"),

  updateProfile: (data) => api.put("/users/updateProfile", data),
};

export default usersService;
